// extracted by mini-css-extract-plugin
export default {"rowTotal":"user-stats_rowTotal__ipZVh","spinner":"user-stats_spinner__fQ-xW"};